import { setInspirationsCurrentStep } from 'features/aiWriter/store/actions/config/actions';
import { AiWriterSidebarStep } from 'features/aiWriter/store/types';
import { AppThunk } from 'store/rootStore';

export const configureChatTabThunk = (): AppThunk<void> => async dispatch => {
  dispatch(setInspirationsCurrentStep({ step: AiWriterSidebarStep.chat, subStep: 'main' }));
};
